var isComponentType = function isComponentType(element, type) {
  return element.type === type;
};

export { isComponentType };